import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./ManageServer.css"; 

const ManageServer = () => {
  const navigate = useNavigate();

  // States
  const [servers, setServers] = useState([]);
  const [filteredServers, setFilteredServers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  
  // Stats State
  const [stats, setStats] = useState({
    total: 0,
    online: 0,
    offline: 0
  });

  // ==========================================
  // ১. সার্ভার লিস্ট ডাটা ফেচ করা (API Fetch)
  // ==========================================
  const fetchServers = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        "https://streamsrvbac.n-tools.info/keymanage/server/list"
      );
      
      const serverData = res.data || [];
      setServers(serverData);
      setFilteredServers(serverData);

      // ক্যালকুলেশন
      const onlineCount = serverData.filter(s => s.status === "active" || s.status === "online").length;
      const offlineCount = serverData.length - onlineCount;

      setStats({
        total: serverData.length,
        online: onlineCount,
        offline: offlineCount
      });

    } catch (err) {
      console.error("Error fetching servers:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServers();
  }, []);

  // ==========================================
  // ২. রিয়েল-টাইম সার্চ ফিল্টার
  // ==========================================
  useEffect(() => {
    const results = servers.filter((srv) =>
      (srv.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (srv.ip || srv.server_ip || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (srv.location || "").toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredServers(results);
  }, [searchTerm, servers]);

  return (
  <div className="manage-server-dashboard-container">
    {/* টপ হেডার সেকশন WITH BACK BUTTON */}
    <div className="manage-server-header-wrapper" style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "24px" }}>
      <button onClick={() => navigate("../")} className="km-back-btn" title="Back to Dashboard">
        ← Back
      </button>
      <div style={{ flex: 1 }}>
        <h2 style={{ margin: 0 }}>Manage Edge Servers</h2>
        <p className="manage-server-subtitle" style={{ margin: 0 }}>Core streaming server infrastructure network link status.</p>
      </div>
      <button className="manage-server-btn-refresh-global" onClick={fetchServers}>
        Refresh Nodes
      </button>
    </div>

      {/* সার্ভার কাউন্টার গ্রিড */}
      <div className="manage-server-grid">
        <div className="manage-server-card" style={{ borderTop: "4px solid #3b82f6" }}>
          <h3>Total Edge Nodes</h3>
          <p>{loading ? "..." : stats.total}</p>
        </div>
        <div className="manage-server-card" style={{ borderTop: "4px solid #22c55e" }}>
          <h3>Online Servers</h3>
          <p>{loading ? "..." : stats.online}</p>
        </div>
        <div className="manage-server-card" style={{ borderTop: "4px solid #64748b" }}>
          <h3>Offline / Inactive</h3>
          <p>{loading ? "..." : stats.offline}</p>
        </div>
        {/* ADD SERVER CARD */}
        <div className="manage-server-card manage-server-add-card" onClick={() => navigate("/add-server")}>
          <h3>+ Add New Server</h3>
          <p>Register Node</p>
        </div>
      </div>

      {/* অ্যাকশন বার */}
      <div className="manage-server-table-actions-bar">
        <div className="manage-server-search-box-wrapper">
          <svg className="manage-server-search-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input
            type="text"
            placeholder="Search by server name, IP address, or location..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="manage-server-search-input"
          />
        </div>
        
        <button className="manage-server-btn-create" onClick={() => navigate("/add-server")}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="manage-server-btn-icon">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Create Server
        </button>
      </div>

      {/* ডাটা টেবিল */}
      {loading ? (
        <div className="manage-server-loading-spinner-wrapper">
          <div className="manage-server-spinner"></div>
          <p>Polling server network list...</p>
        </div>
      ) : (
        <div className="manage-server-responsive-table-wrapper">
          <table className="manage-server-pro-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Server Name</th>
                <th>IP Address</th>
                <th>Location / Region</th>
                <th>Status</th>
                <th>Max Connections</th>
                <th style={{ textAlign: "center" }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredServers.length > 0 ? (
                filteredServers.map((s) => (
                  <tr key={s.id}>
                    <td className="manage-server-text-bold">#{s.id}</td>
                    <td>
                      <span className="manage-server-name-text">{s.name || "Unnamed Node"}</span>
                    </td>
                    <td>
                      <code className="manage-server-ip-block">
                        {s.server_ip || s.ip || "0.0.0.0"}
                      </code>
                    </td>
                    <td>
                      <span className="manage-server-location-badge">
                        {s.location || "Default Zone"}
                      </span>
                    </td>
                    <td>
                      <span className={`manage-server-status-badge ${(s.status === "active" || s.status === "online") ? "online" : "offline"}`}>
                        {(s.status === "active" || s.status === "online") ? "Online" : "Offline"}
                      </span>
                    </td>
                    <td>{s.max_clients || s.max_connections || "Unlimited"}</td>
                    <td>
                      <div className="manage-server-table-row-actions">
                        <button 
                          className="manage-server-btn-row-action manage-server-btn-edit" 
                          onClick={() => navigate(`/edit-server`, { state: { server: s } })}
                        >
                          Edit
                        </button>
                        <button 
                          className="manage-server-btn-row-action manage-server-btn-delete" 
                          onClick={() => alert("Delete / Terminate core API route handler.")}
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="manage-server-no-data-cell">
                    <div className="manage-server-empty-state">
                      <p className="manage-server-empty-title">No servers connected yet.</p>
                      <p className="manage-server-empty-desc">
                        API currently returned an empty list `[]`. Use the **Create Server** button to add your first endpoint.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ManageServer;